import React, { useState } from "react";
import {
  Image,
  Text,
  View,
  StyleSheet,
  TouchableWithoutFeedback,
  LayoutChangeEvent,
  useWindowDimensions,
} from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { Entypo } from "@expo/vector-icons";
import RenderHtml from "react-native-render-html";
import cover from "../../assets/bookcover.png";
// import image1 from "../../assets/1.jpg";

export const CollapsableContainer = ({ children, expanded }) => {
  const [height, setHeight] = useState(0);
  const animatedHeight = useSharedValue(0);

  const onLayout = (event) => {
    const onLayoutHeight = event.nativeEvent.layout.height;

    if (onLayoutHeight > 0 && height !== onLayoutHeight) {
      setHeight(onLayoutHeight);
    }
  };

  const collapsableStyle = useAnimatedStyle(() => {
    animatedHeight.value = expanded ? withTiming(height) : withTiming(0);

    return {
      height: animatedHeight.value,
    };
  }, [expanded]);

  return (
    <Animated.View style={[collapsableStyle, { overflow: "hidden" }]}>
      <View style={{ position: "absolute" }} onLayout={onLayout}>
        {children}
      </View>
    </Animated.View>
  );
};

export const IMAGES = {
  1: { 
    uri: require('../../assets/1.jpg')
  },
  2:{
    uri: require('../../assets/2.jpg')
  },
  3:{
    uri: require('../../assets/3.jpg')
  },
  "4Amharic":{
    uri: require('../../assets/4Amharic.jpg')
  },
  "4English":{
    uri: require('../../assets/4English.jpg')
  },
  "4Oromo":{
    uri: require('../../assets/4Oromo.jpg')
  },
  "4Sidama":{
    uri: require('../../assets/4Sidama.jpg')
  },
  "4Somali":{
    uri: require('../../assets/4Somali.jpg')
  },
  5:{
    uri: require('../../assets/5.jpg')
  },
  6:{
    uri: require('../../assets/6.jpg')
  },
  7:{
    uri: require('../../assets/7.jpg')
  },
  "8Amharic":{
    uri: require('../../assets/8Amharic.jpg')
  },
  "8English":{
    uri: require('../../assets/8English.jpg')
  },
  "8Oromo":{
    uri: require('../../assets/8Oromo.jpg')
  },
  "8Sidama":{
    uri: require('../../assets/8Sidama.jpg')
  },
  "8Somali":{
    uri: require('../../assets/8Somali.jpg')
  },
  9:{
    uri: require('../../assets/9.jpg')
  },
  "bosad_poster":{
    uri: require('../../assets/bosad_poster.png')
  }
}

export const Accordion = ({ item }) => {
  const { width } = useWindowDimensions();
  const [expanded, setExpanded] = useState(false);

  const onItemPress = () => {
    setExpanded(!expanded);
  };


  return (
    <View style={styles.wrap}>
      <TouchableWithoutFeedback onPress={onItemPress}>
        <View style={styles.container}>
          <View style={styles.icon}>
            {!expanded ? (
              <Entypo name="chevron-down" color="black" size={25} />
            ) : (
              <Entypo name="chevron-up" color="black" size={25} />
            )}
          </View>
          {item.image ? (
            <Image source={ IMAGES[item.image].uri} style={styles.image} />
          ) : 
          
          <Image source={cover} style={styles.image} />
          }
          <View style={styles.textContainer}>
            <Text style={styles.text}>{item.title}</Text>
          </View>
        </View>
      </TouchableWithoutFeedback>

      <CollapsableContainer expanded={expanded}>
        <View style={styles.details}>
          {item.image ? (
            <Image source={ IMAGES[item.image].uri} style={styles.header_image} />
          ) : null}
          {item.details ? (
            <RenderHtml
            contentWidth={width}
            source={item.details}
            tagsStyles={tagsStyles}
          />
          ):null}
          
        </View>
      </CollapsableContainer>
    </View>
  );
};

const tagsStyles = {
  ol: {
    paddingRight: "50px",
    // backgroundColor:"#fff",
    textAlign: "justify",
  },
  p: {
    paddingRight: "50px",
    textAlign: "justify",
  },
};

const styles = StyleSheet.create({
  wrap: {
    borderColor: "#ccc",
    borderWidth: 1,
    marginVertical: 5,
    marginHorizontal: 10,
    borderRadius: 20,
    // backgroundColor: "#fcf2ff",
    backgroundColor: "#fff",
  },
  container: {
    flexDirection: "row",
    backgroundColor: "white",
  },
  image: { width: 50, height: 50, margin: 10, borderRadius: 5 },
  //for desktop
  header_image: { width: "100%", aspectRatio: 1, borderRadius: 5 },
  textContainer: { justifyContent: "space-around", width: "90%",flexWrap:"wrap",paddingRight:100 },
  // header_image: { width: "90%", height: 200, borderRadius: 5 },
  // textContainer: { justifyContent: "space-around", paddingRight: 100 },
  details: { margin: 10 },
  text: { opacity: 0.7, fontSize: 15,fontWeight: "bold", textAlign: "left" },
  icon: { marginHorizontal: 5, marginVertical: 20 },
});
